export default __webpack_public_path__ + "static/media/seafood_hero.e8c70e1f.jpg";